var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"ct_box"},[_c('ul',{staticClass:"flex ul1"},_vm._l((_vm.$store.state.UserMediaNav),function(item,index){return _c('li',{key:index,class:_vm.category_id == item.id ? 'active' : '',on:{"click":function($event){return _vm.tab_show(item.id)}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }